import type { IdScanningFaceMatch } from 'garaje/models/screener-result';

interface FaceHoldCopy {
  tile: string;
  feed: string;
}

// Default row: unknown or absent face-match reasons render as a photo mismatch.
const FACE_HOLD_MISMATCH: FaceHoldCopy = {
  tile: 'The visitor photo captured at sign-in doesn’t appear to match the photo on this visitor’s government ID.',
  feed: 'Visitor’s photo doesn’t appear to match their government ID. Please review for entry.',
};

const FACE_HOLD_COPY: Record<string, FaceHoldCopy> = {
  no_photo: {
    tile: 'No visitor photo captured at sign-in.',
    feed: 'No visitor photo captured at sign-in. Please review for entry.',
  },
  no_face_detected: {
    tile: 'No face could be detected in the photo taken at sign-in.',
    feed: 'No face could be detected in the visitor’s photo. Please review for entry.',
  },
  timeout: {
    tile: 'The photo check could not be completed in time.',
    feed: 'Visitor’s photo check could not be completed. Please review for entry.',
  },
};

export function faceHoldCopy(reason: IdScanningFaceMatch['reason']): FaceHoldCopy {
  return (reason && FACE_HOLD_COPY[reason]) || FACE_HOLD_MISMATCH;
}
